// PROPOSITO: datos de demostracion para enseniar la app SIN base de datos ni cuentas.
// DEPENDENCIAS: src/types/dominio.
// NO OBVIO (1): los ejercicios y sus rangos NO son inventados: son el Dia 1 (Upper 1) del plan real
// que Flor entrego en su PowerPoint. Ver docs/fuentes/Data Flor.
// NO OBVIO (2): esto vive en services/ porque es la unica capa que puede ser origen de datos. El
// hook y la pantalla no saben que estan en demo, y por eso el dia que haya base real no se toca ni
// una linea de la interfaz.
// NO OBVIO (3): la columna ANTERIOR trae valores para que se vea el patron de Hevy funcionando. El
// tercer ejercicio va sin historico a proposito, para ensenar el prellenado por prescripcion.

import type { EjercicioDeLaSesion, SesionDeHoy } from '@/types/dominio'

interface Plantilla {
  nombre: string
  series: number
  repsMin: number
  repsMax: number | null
  descansoSeg: number
  anteriorKg: number | null
  anteriorReps: number | null
  pesoObjetivoKg: number | null
}

// Dia 1 — Upper 1: Pecho · Espalda · Hombros · Biceps · Triceps
const UPPER_1: Plantilla[] = [
  { nombre: 'Press de pecho inclinado', series: 3, repsMin: 6, repsMax: 10, descansoSeg: 105, anteriorKg: 22.5, anteriorReps: 8, pesoObjetivoKg: null },
  { nombre: 'Jalón al pecho', series: 3, repsMin: 6, repsMax: 10, descansoSeg: 105, anteriorKg: 40, anteriorReps: 9, pesoObjetivoKg: null },
  { nombre: 'Aperturas en máquina', series: 2, repsMin: 8, repsMax: 12, descansoSeg: 75, anteriorKg: null, anteriorReps: null, pesoObjetivoKg: 25 },
  { nombre: 'Press militar con mancuernas', series: 2, repsMin: 6, repsMax: 10, descansoSeg: 105, anteriorKg: 10, anteriorReps: 10, pesoObjetivoKg: null },
  { nombre: 'Elevaciones laterales con mancuernas', series: 3, repsMin: 12, repsMax: 15, descansoSeg: 75, anteriorKg: 6, anteriorReps: 14, pesoObjetivoKg: null },
  { nombre: 'Extensiones de tríceps en polea', series: 3, repsMin: 10, repsMax: 12, descansoSeg: 75, anteriorKg: 20, anteriorReps: 12, pesoObjetivoKg: null },
  { nombre: 'Curl de bíceps barra Z', series: 3, repsMin: 8, repsMax: 12, descansoSeg: 75, anteriorKg: 15, anteriorReps: 10, pesoObjetivoKg: null },
]

function construir(plantilla: Plantilla, indice: number): EjercicioDeLaSesion {
  return {
    programaEjercicioId: `demo-ejercicio-${String(indice)}`,
    ejercicioId: `demo-biblioteca-${String(indice)}`,
    nombre: plantilla.nombre,
    orden: indice + 1,
    seriesProgramadas: plantilla.series,
    repsMin: plantilla.repsMin,
    repsMax: plantilla.repsMax,
    segundos: null,
    descansoSeg: plantilla.descansoSeg,
    pesoObjetivoKg: plantilla.pesoObjetivoKg,
    rir: 2,
    nota: null,
    videoUrl: null,
    clipLigeroUrl: null,
    series: Array.from({ length: plantilla.series }, (_, i) => ({
      id: '',
      clienteId: '',
      numeroSerie: i + 1,
      anterior:
        plantilla.anteriorKg === null
          ? null
          : { pesoKg: plantilla.anteriorKg, reps: plantilla.anteriorReps },
      // Prellenado: lo de la ultima vez; si no hay historico, la prescripcion de Flor.
      pesoKg: plantilla.anteriorKg ?? plantilla.pesoObjetivoKg,
      reps: plantilla.anteriorReps ?? plantilla.repsMin,
      segundos: null,
      tipo: 'efectiva' as const,
      completadaAt: null,
    })),
  }
}

export function sesionDeDemostracion(fecha: string): SesionDeHoy {
  return {
    id: 'demo-sesion',
    programaDiaId: 'demo-dia-1',
    fecha,
    nombreDelDia: 'Upper 1',
    gruposMusculares: ['Pecho', 'Espalda', 'Hombros', 'Bíceps', 'Tríceps'],
    estado: 'en_curso',
    ejercicios: UPPER_1.map(construir),
  }
}

export const PERFIL_DE_DEMOSTRACION = {
  id: 'demo-perfil',
  rol: 'alumna' as const,
  nombre: 'Alumna de prueba',
  telefono: null,
  zonaHoraria: 'America/Santiago',
}

export const ALUMNA_DE_DEMOSTRACION = 'demo-alumna'
